import React from 'react';

import classes from './Divider.scss';

const divider = (props) => {

    let divider = null;

    if (props.type === 'dashed') {
        divider = <div className={classes.Dashed}>OR</div>;
    } 
     if (props.type === 'normal') {
        divider = <div className={classes.Normal}></div>;
    }
    return (
        <React.Fragment>
            {divider}
        </React.Fragment>
    );
}

export default divider;


// WEBPACK FOOTER //
// ./src/components/UI/Divider/Divider.js